// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"a135f6af","209":"97fd5528","829":"c0d058de","878":"9313c48a"}[chunkId] + ".chunk.js";
};